import { render, staticRenderFns } from "./CalloutCard.vue?vue&type=template&id=da424748&scoped=true"
import script from "./CalloutCard.vue?vue&type=script&lang=js"
export * from "./CalloutCard.vue?vue&type=script&lang=js"
import style0 from "./CalloutCard.vue?vue&type=style&index=0&id=da424748&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da424748",
  null
  
)

export default component.exports